import { useRouter } from 'next/router'

interface LocalStorage {
  url: string
  completeUrl: string
  storageDataName: string
}

const localStorages: LocalStorage[] = [
  {
    // お問い合わせ
    url: '/contact',
    completeUrl: '/contact/thanks',
    storageDataName: 'refContactPage',
  },
  {
    // [資料ダウンロード]UI/UX＆モダナイズ開発サービス紹介ガイド
    url: '/download/about',
    completeUrl: '/download/about/done',
    storageDataName: 'refDownloadAboutPage',
  },
  {
    // [資料ダウンロード]継続開発プラン資料
    url: '/download/od',
    completeUrl: '/download/od/done',
    storageDataName: 'refDownloadOdPage',
  },
  {
    // [資料ダウンロード]サイト改善ソリューション資料
    url: '/download/growthhack',
    completeUrl: '/download/growthhack/done',
    storageDataName: 'refDownloadGrowthhackPage',
  },
  {
    // [資料ダウンロード]バリュープロポジションキャンバス
    url: '/download/value-proposition',
    completeUrl: '/download/value-proposition/done',
    storageDataName: 'refDownloadValuepropositionPage',
  },
  {
    // [資料ダウンロード]ペルソナ設計
    url: '/download/persona',
    completeUrl: '/download/persona/done',
    storageDataName: 'refDownloadPersonaPage',
  },
  {
    // [資料ダウンロード]リーンキャンバス
    url: '/download/lean',
    completeUrl: '/download/lean/done',
    storageDataName: 'refDownloadLeanPage',
  },
  {
    // [資料ダウンロード]ビジネスモデル
    url: '/download/business-model',
    completeUrl: '/download/business-model/done',
    storageDataName: 'refDownloadBusinessmodelPage',
  },
  {
    // [資料ダウンロード]ユーザー調査
    url: '/download/customer-journy-map',
    completeUrl: '/download/customer-journy-map/done',
    storageDataName: 'refDownloadCustomerjournymap',
  },
  {
    // [資料ダウンロード]ユーザビリティチェックリスト
    url: '/download/usabilitychecklist',
    completeUrl: '/download/usabilitychecklist/done',
    storageDataName: 'redDownloadUsabilityChecklistPage',
  },
  {
    // [資料ダウンロード]ウェブアクセシビリティチェックリスト
    url: '/download/webaccessibilitychecklist',
    completeUrl: '/download/webaccessibilitychecklist/done',
    storageDataName: 'refDownloadWebAccessibilityChecklistPage',
  },
  {
    // [資料ダウンロード]デザインプロセス
    url: '/download/design-process',
    completeUrl: '/download/design-process/done',
    storageDataName: 'refDownloadDesignProcessPage',
  },
  {
    // [資料ダウンロード]PMM
    url: '/download/pmmchecklist',
    completeUrl: '/download/pmmchecklist/done',
    storageDataName: 'refPmmChecklistDownloadPage',
  },
  {
    // [資料ダウンロード]プロトタイピングサービス
    url: '/download/prototyping',
    completeUrl: '/download/prototyping/done',
    storageDataName: 'refPrototypingDownloadPage',
  },
  {
    // [資料ダウンロード]flamingo
    url: '/download/flamingo',
    completeUrl: '/download/flamingo/done',
    storageDataName: 'refFlamingoDownloadPage',
  },
  {
    // [資料ダウンロード]chaos
    url: '/download/mobile-app-technology-chaos-map-2025',
    completeUrl: '/download/mobile-app-technology-chaos-map-2025/done',
    storageDataName: 'refChaosDownloadPage',
  },
  {
    // [資料ダウンロード]PMMのすべて
    url: '/download/pmm-complete-guide',
    completeUrl: '/download/pmm-complete-guide/done',
    storageDataName: 'refPmmCompleteGuideDownloadPage',
  },
  {
    // [資料ダウンロード]デザインシステム発注ガイド
    url: '/download/design-system',
    completeUrl: '/download/design-system/done',
    storageDataName: 'refDownloadDesignSystemPage',
  },
  {
    // [LP]UIUXデザイン
    url: '/services/uiuxdesign-lp2',
    completeUrl: '/lp-ui-contact-completed',
    storageDataName: 'refLPContactPage',
  },
  {
    // [LP]フロントエンド
    url: '/services/frontend-dev',
    completeUrl: '/lp-frontend-contact-completed',
    storageDataName: 'refFrontendLPContactPage',
  },
  {
    // [LP]バックエンド
    url: '/services/backend-dev',
    completeUrl: '/lp-backend-contact-completed',
    storageDataName: 'refBackendLPContactPage',
  },
  {
    // [LP]デザインシステム
    url: '/services/designsystem',
    completeUrl: '/lp-designsystem-contact-completed',
    storageDataName: 'refDesignSystemLPContactPage',
  },
  {
    // 会宝産業 資料DL
    url: '/download/kaiho',
    completeUrl: '/download/kaiho/done',
    storageDataName: 'refKaihoDownloadPage',
  },
  {
    // カネカ 資料DL
    url: '/download/kaneka',
    completeUrl: '/download/kaneka/done',
    storageDataName: 'refKanekaDownloadPage',
  },
  {
    // amazonecsLP問い合わせ
    url: '/services/amazonecs',
    completeUrl: '/services/amazonecs/thanks',
    storageDataName: 'refAmazonEcsLpContactPage',
  },
  {
    // awsapprunnerLP問い合わせ
    url: '/services/awsapprunner',
    completeUrl: '/services/awsapprunner/thanks',
    storageDataName: 'refAwsAppRunnerLpContactPage',
  },
  {
    // awscodepipelineLP問い合わせ
    url: '/services/awscodepipeline',
    completeUrl: '/services/awscodepipeline/thanks',
    storageDataName: 'refAwsCodePipeLineLpContactPage',
  },
  {
    // AwsFargateLP問い合わせ
    url: '/services/awsfargate',
    completeUrl: '/services/awsfargate/thanks',
    storageDataName: 'refAwsFargateLpContactPage',
  },
  {
    // CircleCiLP問い合わせ
    url: '/services/circleci',
    completeUrl: '/services/circleci/thanks',
    storageDataName: 'refCircleCiLpContactPage',
  },
  {
    // GithubActionsLP問い合わせ
    url: '/services/githubactions',
    completeUrl: '/services/githubactions/thanks',
    storageDataName: 'refGithubActionsLpContactPage',
  },
  {
    // GitLabLP問い合わせ
    url: '/services/gitlab',
    completeUrl: '/services/gitlab/thanks',
    storageDataName: 'refGitLabLpContactPage',
  },
  {
    // ZebraLP問い合わせ
    url: '/services/zebra',
    completeUrl: '/services/zebra/thanks',
    storageDataName: 'refZebraLpContactPage',
  },
  {
    // メールマガジン登録
    url: '/mailmagazine',
    completeUrl: '/mailmagazine/thanks',
    storageDataName: 'refMailmagazinePage',
  },
]

const LocalStorage: React.FC = () => {
  const router = useRouter()

  localStorages.map(({ url, completeUrl, storageDataName }) => {
    if (router.pathname === url) {
      if (process.browser) {
        localStorage.setItem(storageDataName, 'true')
      }
    } else if (router.pathname === completeUrl) {
      // 何もしない
    } else {
      if (process.browser) {
        localStorage.removeItem(storageDataName)
      }
    }
  })

  return <></>
}

export default LocalStorage
